import { render, staticRenderFns } from "./SchoolOfBaa.vue?vue&type=template&id=5bd695d0"
import script from "./SchoolOfBaa.vue?vue&type=script&lang=js"
export * from "./SchoolOfBaa.vue?vue&type=script&lang=js"
import style0 from "./SchoolOfBaa.vue?vue&type=style&index=0&id=5bd695d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports